import createLucideIcon from '../createLucideIcon';

const Music3 = createLucideIcon('Music3Icon', [
  ['circle', { cx: '12', cy: '18', r: '4', key: 'm3r9ws' }],
  ['path', { d: 'M16 18V2', key: '40x2m5' }],
]);

export default Music3;
